import { useAuth0 } from "@auth0/auth0-react";
import DelegatedPage from '@components/Dashboard/DelegatedPage';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

export default function Dashboard({ listOfUsers }) {
  const { isAuthenticated } = useAuth0();
  const listOfAdministrators = listOfUsers.filter((user) => user.userType === 'administrator');
  const listOfOperators = listOfUsers.filter((user) => user.userType === 'operator');


  const administratorsTable = <>
    <h1>Administrators</h1>
    <table className="table">
      <thead>
        <tr>
          <th scope="col">Photo</th>
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">State</th>
          <th scope="col"># of presences</th>
        </tr>
      </thead>
      <tbody>
        {listOfAdministrators.map((user) =>
          <tr key={user.id}>
            <td><img src={user.picture} alt="the face of the user" /></td>
            <td>{user.name}</td>
            <td>{user.email}</td>
            <td>{user.state}</td>
            <td>{user.presence}</td>
          </tr>)}
      </tbody>
    </table>
  </>

  const operatorsTable = <>
    <h1>Operators</h1>
    <table className="table">
      <thead>
        <tr>
          <th scope="col">Photo</th>
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">State</th>
          <th scope="col">Assigned vehicle</th>
          <th scope="col"># of presences</th>
        </tr>
      </thead>
      <tbody>
        {listOfOperators.map((user) =>
          <tr key={user.id}>
            <td><img src={user.picture} alt="the face of the user" /></td>
            <td>{user.name}</td>
            <td>{user.email}</td>
            <td>{user.state}</td>
            <td>{user.assignedVehicle ? user.assignedVehicle : 'none'}</td>
            <td>{user.presence}</td>
          </tr>)}
      </tbody>
    </table>
  </>


  return (!isAuthenticated) ? <>Restricted access</> : (
    <><h2>Dashboard</h2>
      <Tabs defaultActiveKey="viewUserList" id="uncontrolled-tab-example" className="mb-3">
        <Tab eventKey="viewUserList" title="View connections">
        {listOfAdministrators.length > 0 && administratorsTable}
        {listOfOperators.length > 0 && operatorsTable}
        </Tab>
        <Tab eventKey="editUserList" title="Edit user database">
          <DelegatedPage />
        </Tab>
      </Tabs>
    </>
  );
}
